import type { ErklaerungStatus, KostenuebernahmeForm } from '@/types/erklaerung';

const API_BASE = '/api/zuzahler/erklaerung';

export async function getErklaerung(token: string): Promise<ErklaerungStatus> {
  const r = await fetch(`${API_BASE}/${encodeURIComponent(token)}`);
  if (r.status === 404) throw { code: 'not_found' as const };
  if (r.status === 410) throw { code: 'expired' as const };
  if (!r.ok) throw { code: 'error' as const, status: r.status };
  return r.json() as Promise<ErklaerungStatus>;
}

export async function verifyBirthdate(token: string, birthdate: string): Promise<{ ok: true }> {
  const r = await fetch(`${API_BASE}/${encodeURIComponent(token)}/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ birthdate }),
  });
  if (r.status === 423) {
    const body = await r.json();
    throw { code: 'locked' as const, until: body.until };
  }
  if (r.status === 401) throw { code: 'wrong_birthdate' as const };
  if (!r.ok) throw { code: 'error' as const, status: r.status };
  return r.json();
}

export async function saveDraft(token: string, form: KostenuebernahmeForm): Promise<void> {
  const r = await fetch(`${API_BASE}/${encodeURIComponent(token)}/draft`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  });
  if (!r.ok) throw new Error(`Draft-Save fehlgeschlagen: ${r.status}`);
}

export async function submitErklaerung(token: string, form: KostenuebernahmeForm): Promise<{ ok: true }> {
  const r = await fetch(`${API_BASE}/${encodeURIComponent(token)}/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  });
  if (r.status === 400) {
    const body = await r.json();
    throw { code: 'validation' as const, errors: body.errors || [] };
  }
  if (r.status === 409) throw { code: 'already_signed' as const };
  if (!r.ok) throw { code: 'error' as const, status: r.status };
  return r.json();
}
